import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=f6960a3a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=f6960a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6960a3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6960a3a')) {
      api.createRecord('f6960a3a', component.options)
    } else {
      api.reload('f6960a3a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=f6960a3a&scoped=true&", function () {
      api.rerender('f6960a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oICB6BKEZJ4t/JS/teamMember.vue"
export default component.exports